export function headerActions() {
    const $body = $("body");
    const $header = $(".header");
    const $menuOpener = $(".menu-opener");
    const $mainNavList = $header.find(".main-nav");
    const hasDrop = $mainNavList.find(".item-has-children");

    hasDrop.each(function () {
        $(this).find(">a").after('<button class="header-mobile-menu-opener"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">\n' +
            '  <path d="M1 1.5L7 7.5L13 1.5" stroke="#160C55" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg><svg class="for-desktop" xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">\n' +
            '  <path d="M1.37976 1.5L4.37976 4.5L7.37976 1.5" stroke="#160C55" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>');
    });
    $menuOpener.on("click", function () {
        $body.toggleClass("main-menu-open");
        $body.removeClass("menu-drop-open");
        hasDrop.removeClass("show-drop");
    });
    hasDrop.on("click", ".header-mobile-menu-opener", function (e) {
        e.preventDefault();
        let $this = $(this);
        if (!$this.parent().hasClass("show-drop")) {
            hasDrop.removeClass("show-drop");
            $this.parent().addClass("show-drop");
            if (window.innerWidth < 1200) {
                hasDrop.find(".custom-drop").slideUp(500);
                $this.parent().find(".custom-drop").slideDown(500);
            }
        } else {
            $this.parent().removeClass("show-drop");
            if (window.innerWidth < 1200) {
                $this.parent().find(".custom-drop").slideUp(500);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerActions.js